import './ChannelPreview.scss';
import { Button } from 'primereact/button';
import ChannelsService from 'data/ChannelsService';
import React from 'react';

class ChannelPreview extends React.Component {

  constructor() {
    super();
    this.channelsService = new ChannelsService.Factory().create();
    this.state = { active: true };
  }

  disconnect() {
    this.channelsService.remove(this.channel.getId());
  }

  toggleActive() {
    const active = !this.state.active;
    this.channel.setActive(active);
    this.setState({ active });
  }

  render() {
    this.channel = this.props.channel;
    if (!this.channel) {
      return '';
    }
    const toggleActiveIcon = this.state.active ? 'pi-lock-open' : 'pi-lock';
    return (
      <div className='ChannelPreview'>
        <span className='name'>{this.channel.getId()}</span>
        <span className='status'>{this.channel.getStatus() || ''}</span>
        <span className='buttonGroup'>
          <Button icon={`pi ${toggleActiveIcon}`}
              onClick={this.toggleActive.bind(this)} />
          <Button icon='pi pi-times' onClick={this.disconnect.bind(this)} />
        </span>
      </div>
    );
  }
}

export default ChannelPreview;

